import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import PanelGroup from 'react-bootstrap/lib/PanelGroup';
import Panel from 'react-bootstrap/lib/Panel';
import Collapse from 'react-bootstrap/lib/Collapse';
 //import '../../assets/css/grid.css';
//import '../../assets/css/singleChoice.css'
import { getPrintPreview, optionPrintPreview } from './utils'
import {parseHtmlForReact} from './../helpers'
import * as R from 'ramda'

@observer
export default class Grid extends Component {

    @observable selectedPanel = 0

    previousCheckedIndex = {}

    constructor(props){
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleSingleChoiceChange = this.handleSingleChoiceChange.bind(this)
        this.isChecked = this.isChecked.bind(this)
        this.handleCellClick = this.handleCellClick.bind(this)
        this.generateHeaders = this.generateHeaders.bind(this)
        this.generateRows = this.generateRows.bind(this)
        this.generateSingleChoices = this.generateSingleChoices.bind(this)
        this.getInputType = this.getInputType.bind(this)
        this.hoverGridColumnHandler = this.hoverGridColumnHandler.bind(this)
        this.handlePanelClick = this.handlePanelClick.bind(this)
        this.inputtypes //used to track input types ie radio or checkbox
        this.colCount = 0
        this.gridTitleWidth = "40%"
        this.gridRef = React.createRef()
        this.state = {
            hoverIndex: undefined,
            accordionSelected: 0,
            gridWidthIsOverflowing: false,
        }
    }

    componentDidMount = () => {
        const { question, store } = this.props
        const questionId = question.id
        const { scrollWidth, clientWidth } = this.gridRef.current
        const copyOfState = { ...this.state }
        if (clientWidth < scrollWidth) {
            copyOfState.gridWidthIsOverflowing = true
            this.setState(copyOfState)
        }
        this.e = document.getElementById(`${questionId}_header`)
        if (this.e) {
            this.c = this.e.children[0]
            this.p = this.e.parentElement
            this.answerChildren = [...this.e.children].splice(1)
            this.answerChildrenWidth = (this.p.offsetWidth - this.c.offsetWidth) / this.answerChildren.length
            const w = window.innerHeight
            this.topOffset = null

            if (!store.printMode && !store.displayForMobile() && this.p.offsetHeight/w*100 > 80) {
                window.addEventListener('scroll', this.scrollListener)
            }
        }
    }

    setFloatingAnswerWidths = () => {
        this.c.setAttribute('style', `width: ${this.c.offsetWidth}px !important;`)
        this.answerChildren.forEach(el => el.setAttribute('style', `width: ${this.answerChildrenWidth}px !important;`))
    }

    scrollListener = (e) => {
        if (this.topOffset === null) {
            this.headerHeight = this.e.offsetHeight
            this.p.style.paddingTop = `${this.headerHeight}px`
        }
        this.topOffset = this.p.getBoundingClientRect().y + window.scrollY
        this.maxTopOffset = this.topOffset + (this.p.offsetHeight - window.innerHeight * 0.7 + this.headerHeight)

        const top = window.scrollY - this.topOffset

        if (top > 0 && window.scrollY < this.maxTopOffset) {
            if (!this.moveHeader) {
                this.setFloatingAnswerWidths()
                this.e.setAttribute('style', `position: absolute; z-index: 10; transform: translateY(${-this.headerHeight}px); background: #FFF`)
                this.moveHeader = true
            } else {
                this.e.style.transform = `translateY(${top - this.headerHeight}px)`
            }
        } else if (top <= 0) {
            this.setFloatingAnswerWidths()
            this.e.setAttribute('style', `position: absolute; transform: translateY(${-this.headerHeight}px)`)
            this.moveHeader = false
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollListener)
    }

    getSets = () => {
        const {question, store}  = this.props
        const {isFlipped} = question.settings.frontend
        const flip = isFlipped && !store.displayForMobile()
        const rowSet =  !flip ? question.optionSetY : question.optionSetX
        const columnSet = !flip ? question.optionSetX : question.optionSetY
        return {
            rowSet,
            columnSet
        }
    }

    getIds = (row, column) => {
        const {question, store}  = this.props
        const {isFlipped} = question.settings.frontend
        const flip = isFlipped && !store.displayForMobile()
        const rowId = !flip ? row.id : column.id
        const columnId = !flip ? column.id : row.id

        return {
            rowId,
            columnId,
        }
    }

    getInputType(rowid, columnid){
        return this.inputtypes[rowid, columnid]
    }

    handleChange(fieldType, e) {
        const {question, store} = this.props
        store.nextButtonClicked = false
        const arrValues = e.target.name.split('_')
        const rowId = arrValues[0]
        const columnId = arrValues[1]
        const valueObj = {
            rowid: rowId,
            columnid: columnId
        }
        store.addFormResponse(question, valueObj, this.inputtypes)
    }

    handleCellClick(rowId, columnId, fieldType, e){
        const {question, store} = this.props
        const valueObj = {
            rowid: rowId,
            columnid: columnId
        }
        store.addFormResponse(question, valueObj, this.inputtypes)
    }

    getText = (option) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        if (option.langs[langcode]) {
            ({ text } = option.langs[langcode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }
        return text
    }

    generateHeaders(columnSet, questionId, isRtlLanguage) {
        // generate our header (th) cell components
        const {question, store} = this.props
        const columnOptions = columnSet.options.filter(o => o.willDisplay !== false)
        const width = 60 / columnOptions.length
        
        const arrRest = columnOptions.map((option, index) => {
            const validationFails = 
                question.validator.options.has(option.id) && question.validator.options.get(option.id).error
                    ? true 
                    : false
            const isHovered = (index === this.state.hoverIndex) ? 'grid__row__col--hovered radius' : ''
            let columnClass = validationFails ? 'gridcol validationError radius' : 'gridcol'
            columnClass += (store.printMode && option.parentQuestionId) ? ' inheritPreview' : ''
            return option.isHidden ? null : 
                <div
                    data-index={index}
                    className={`${columnClass} grid__row__col ${isHovered}`}
                    onMouseEnter={this.hoverGridColumnHandler}
                    style={{"width": width+"%"}}
                    key={"col_"+option.id}
                    id={`${questionId}_col_${index}`}
                >
                    {parseHtmlForReact(store.getOptionTitle(option, question))} 
                    {store.printMode ? optionPrintPreview(option) : null}
                </div>
        });
        arrRest.unshift(<div key='warningRemovingKey' className={`grid__row__col grid__row__col--title`}></div>)
        return (
            <div id={`${questionId}_header`} className="grid__row grid__row--header">
                {arrRest}
            </div>
        )
    }

    isChecked(rowId, columnId){
        const {question, store} = this.props
        const {form_data} = store
        return form_data.has(question.id)
            && form_data.get(question.id).data.has(rowId)
            && form_data.get(question.id).data.get(rowId).has(columnId)
            && form_data.get(question.id).data.get(rowId).get(columnId) ? true : false
    }

    renderLines = (getTransitionDelay, transitionDuration, isBefore, index, checkedIndex, lineColor) => {
        const { question } = this.props
        if (!R.pathOr(false, ['settings', 'frontend', 'renderLines'], question)) return null

        const isChecked = index <= checkedIndex 
        let background = (
            (isBefore && isChecked)
            || (index < checkedIndex)
        )
            ? lineColor
            : undefined
        return (
            <Fragment>
                <div
                    className="line"
                    style={{
                        top: '50%',
                        left: isBefore ? '0%' : '50%',
                        width: '50%',
                    }}
                />
                <div
                    className="line animated"
                    style={{
                        left: isBefore ? '0%' : '50%',
                        width: (isChecked) ? '50%' : '0%',
                        background, //: (index <= checkedIndex) ? lineColor : undefined,
                        transitionDelay: `${getTransitionDelay()}ms`,
                        transitionDuration: `${transitionDuration}ms`,
                    }}
                />
            </Fragment>
        )
    }

    generateRows(questionId, rowSet, columnSet, questionType, isRtlLanguage){
        this.inputtypes = {}
        const {question, store} = this.props
        const {isFlipped} = question.settings.frontend
        const { form_data, langcode } = store
        const getInputType = (column, row) => {
            const targetSet = isFlipped ? row : column
            return !targetSet.hasOwnProperty("fieldType") || targetSet.fieldType === "RD" ? "radio" : "checkbox"
        }
        const rowOptions = rowSet.options.filter(o => o.willDisplay !== false)
        const columnOptions = columnSet.options.filter(o => o.willDisplay !== false)
        const width = 60 / columnOptions.length
        let rowIndex = 0
        const rows = rowOptions.map((row) => {
            if (row.isHidden) {
                return null
            }
            const validationFails = !columnSet.isExclusive && question.validator.options.has(row.id)
                && question.validator.options.get(row.id).error ? true : false
            const validationMsg = validationFails ? question.validator.options.get(row.id).message : null
            const rowValidationClass = validationFails ? 'gridrow validationError radius' : 'gridrow'
            const stripeClass = rowIndex % 2 === 0 ? 'even' : 'odd'
            const rowClass = rowValidationClass + ' ' + stripeClass
            const rowValidation = (store.nextButtonClicked && validationFails) ? <span className="validationError radius">{validationMsg}</span> : null

            const numberOfOptions = columnOptions.length
            const checkedIndex = columnOptions.findIndex((column) => {
                const {rowId, columnId} = this.getIds(row, column)
                return this.isChecked(rowId, columnId)
            })

            const colorCodes = [
                '#E8555F',
                '#F5A161',
                '#F9EB4C',
                '#9EC758',
                '#59B362',
            ]

            const lineColor = R.pathOr(undefined, [Math.max(0, checkedIndex)], colorCodes)

            const cells = [
            <div
                key={"rowtitle_"+questionId+"_"+row.id} 
                className={`gridcol1 grid__row__col grid__row__col--title ${isRtlLanguage ? 'rtl' : ''} ${row.parentQuestionId && store.printMode ? ' inheritPreview' : ''}`}
                style={{"width": this.gridTitleWidth }}
            >
                {parseHtmlForReact(store.getOptionTitle(row, question))}
                {store.printMode ? optionPrintPreview(row) : null}
                {rowValidation}
            </div>]
            const transitionDuration = (500 / (numberOfOptions) / 2)
            const reverseTransition = R.pathOr(0, [row.id], this.previousCheckedIndex) > checkedIndex 
            let transitionDelay = reverseTransition
                ? 500
                : 0
            
            const getTransitionDelay = () => {
                const delay = transitionDelay
                if (reverseTransition) {
                    transitionDelay -= transitionDuration
                } else {
                    transitionDelay += transitionDuration
                }
                return delay
            }

            this.previousCheckedIndex[row.id] = checkedIndex

            const cellsRest = columnOptions.map((column, index) => {
                //only show checkboxes if it's a grid (not a rating question)
                const { rowId, columnId } = this.getIds(row, column)
                
                const isFirst = index === 0
                const isLast = (index === (numberOfOptions - 1))

                const fieldType = ['TB', 'SG'].includes(questionType) ? getInputType(column, row) : 'radio'
                const checked = this.isChecked(rowId, columnId)
                const cellid = questionId+"_"+rowId+"_"+columnId
                if (!Object.hasOwnProperty.call(this.inputtypes, rowId)) {
                    this.inputtypes[rowId] = {}
                }
                const isHovered = (index === this.state.hoverIndex) ? 'grid__row__col--hovered radius' : ''
                this.inputtypes[rowId][columnId] = fieldType
                this.colCount += column.isHidden ? 0 : 1
                const inputTypeClass = (fieldType === 'radio') ? 'radio-button' : 'checkbox'
                return column.isHidden ? null : 
                    <div
                        className={`gridcol clickable grid__row__col ${isHovered} ${isRtlLanguage ? 'rtl' : ''}`}
                        key={"cell_"+rowId+"_"+columnId} 
                        style={{"width": width+"%"}}
                    >
                        {!isFirst && (
                            this.renderLines(getTransitionDelay, transitionDuration, true, index, checkedIndex, lineColor)
                        )}
                        <label onMouseEnter={this.hoverGridColumnHandler} data-index={index} className={inputTypeClass}>
                            <input
                                name={rowId+"_"+columnId}
                                key={"input_"+rowId+"_"+columnId}
                                id={cellid}
                                type={fieldType}
                                value={columnId}
                                checked={checked}
                                onChange={this.handleChange.bind(this, fieldType)}
                            />
                            <span className="checkmark"></span>
                        </label>
                        {!isLast && (
                            this.renderLines(getTransitionDelay, transitionDuration, false, index, checkedIndex, lineColor)
                        )}
                    </div>
            });
            rowIndex++
            return (
                <Fragment>
                    <div className={`${rowClass} grid__row`}  key={"row_"+questionId+"_"+row.id}>
                        {cells.concat(cellsRest)}
                    </div>
                </Fragment>
            )
        });
        return rows
    }

    handleSingleChoiceChange(rowOptionId, rowIndex, e) {
        /**
         * Executes when input is selected/clicked
         */
        const {question, store} = this.props
        store.nextButtonClicked = false
        const colOptionId = e.target.value
        const valueObj = {
            rowid: rowOptionId.toString(),
            columnid: colOptionId.toString()
        }
        this.selectedPanel = (rowIndex + 1)
        store.addFormResponse(question, valueObj, this.inputtypes)
        const copyOfState = { ...this.state }
        copyOfState.accordionSelected = rowIndex + 1
        this.setState(copyOfState)
    }

    selectPanel = () => {
        this.selectedPanel = 0
    }

    hoverGridColumnHandler (e) {
        const { index } = e.target.dataset
        const copyOfState = { ...this.state }
        copyOfState.hoverIndex = parseInt(index, 10)
        this.setState(copyOfState)
    }

    handlePanelClick = (e, index) => {
        /**
         * Executes when panel title is clicked
         */
        const copyOfState = { ...this.state }
        if (copyOfState.accordionSelected !== index) {
            copyOfState.accordionSelected = index
            this.selectedPanel = index
        } else {
            // allow collapsing current row
            copyOfState.accordionSelected = -1
            this.selectedPanel = -1
        }
        this.setState(copyOfState)
    }

    generateSingleChoices(rowSet, columnSet){
        const { question, store } = this.props
        const { form_data } = store
        const questionType = question.questionTypeCode
        const questionId = question.id

        this.inputtypes = {}
        const getInputType = (column) => {
            return column.fieldType === "RD" ? "radio" : "checkbox"
        }
        const elem = rowSet.options.filter(o => o.willDisplay !== false).map((row, index) => {
            if (row.isHidden) {
                return null
            }
            const validationFails = !columnSet.isExclusive && question.validator.options.has(row.id)
                && question.validator.options.get(row.id).error ? true : false
            const validationMsg = validationFails ? question.validator.options.get(row.id).message : null
            const rowValidation = store.nextButtonClicked && validationMsg ? <div className="validationError radius">{validationMsg}</div> : null
            let hasCHOption = false
            const radioButtons = columnSet.options.filter(o => o.willDisplay !== false).map((column) => {
                const {rowId, columnId} = this.getIds(row, column)
                if (!Object.hasOwnProperty.call(this.inputtypes, rowId)) {
                    this.inputtypes[rowId] = {}
                }
                const fieldType = ['TB', 'SG'].includes(questionType) && column.hasOwnProperty("fieldType") ? getInputType(column) : 'radio'
                hasCHOption = hasCHOption || fieldType === 'checkbox'
                this.inputtypes[rowId][columnId] = fieldType
                const checked = this.isChecked(rowId, columnId)
                const inputTypeClass = (fieldType === 'radio') ? 'radio-button' : 'checkbox'
                return column.isHidden ? null : (
                    <div key={column.id}>
                        <label className={inputTypeClass}>
                        <input 
                            type={fieldType}
        					name={questionId+"_"+row.id}
        					value={columnId}
        					id={column.id}
        					checked={checked}
        					onChange={this.handleSingleChoiceChange.bind(this, rowId, index)} 
                        />
                            <span className="checkmark"></span>
                            {parseHtmlForReact(store.getOptionTitle(column, question))}
                            {store.printMode ? optionPrintPreview(column) : null}
                        </label>
    				</div>
                )
            });

            let answerHasBeenChosen
            if (form_data.has(question.id) && form_data.get(question.id).data.has(row.id)) {
                const hasMap = form_data.get(question.id).data.get(row.id)._hasMap
                const arrayOfAnswers = Array.from(hasMap.values())
                answerHasBeenChosen = arrayOfAnswers.some((item) => item.value === true)
            }

            let icon
            if (answerHasBeenChosen) {
                icon = <i className="fas fa-check-circle"></i>
            } else if (this.state.accordionSelected === index) {
                icon = <i className="fas fa-minus-circle"></i>
            } else if (hasCHOption) {
                icon = <i className="fas fa-times-circle"></i>
            } else {
                icon = <i className="fas fa-plus-circle"></i>
            }
            
            return (
                <div
                    key={row.id}
                    id={`panel_${row.id}`} 
                    className={`panel radius panel-default ${(index === this.state.accordionSelected) ? 'panel--active' : ''}`}
                >
                    <div className='panel-heading' data-index={index} onClick={(e) => { this.handlePanelClick(e, index) }}>
                        <div className='panel-title'>
                            <h3>
                                {parseHtmlForReact(store.getOptionTitle(row, question))}
                                {icon}
                            </h3>
                            {rowValidation}
                            {store.printMode ? optionPrintPreview(row) : null}
                        </div>
                    </div>
                    <Collapse in={this.selectedPanel === index || hasCHOption}>
                        <div className={`panel-collapse`}>
                            <div className='gridAsSingleChoice_1 panel-body'>
                                {radioButtons}
                            </div>
                        </div>
                    </Collapse>
                </div>
            )

        })
        return <PanelGroup accordion activeKey={this.selectedPanel} onSelect={this.selectPanel} className='accordion'>{elem}</PanelGroup>
    }

    gradient = () => {
        const { question, store } = this.props
        if (question.settings.frontend.showGradient) {
            return <div style={{ marginLeft: this.gridTitleWidth }} className="gradient"></div>
        }
        return null
    }

    render() {
        const { question, store } = this.props
        const { is_rtl_language } = store
        const { isFlipped } = question.settings.frontend
        const questionType = question.questionTypeCode
        const questionId = question.id
        const {rowSet, columnSet} = this.getSets()
        var elem
        if(!store.displayForMobile() && !this.state.gridWidthIsOverflowing) {
            const headerComponents = this.generateHeaders(columnSet, questionId, is_rtl_language)
            const rowComponents = this.generateRows(questionId, rowSet, columnSet, questionType, is_rtl_language)
            elem = 
                <div className={`grid ${(isFlipped) ? 'grid--flipped' : 'grid-normal'} 
                ${(R.pathOr(false, ['settings', 'frontend', 'renderLines'], question))
                ? 'lines'
                : ''}`}>
                    {headerComponents}
                    {rowComponents}
                </div>
        } else {
            elem = this.generateSingleChoices(rowSet, columnSet)
        }
        return (
            <div ref={this.gridRef}>
                {getPrintPreview(question, store)}
                {elem}
                {this.gradient()}
            </div>
        );
    }
}
